/* 事前審査結果 */
import React, { useState } from 'react';
import RowTemplate from '../atoms/RowTemplate';
import ShelfInShelf from '../molecules/ShelfInShelf';
import { convertLine } from '../Convert';
import { Col, Row } from 'react-bootstrap';
import Paragraph from '../molecules/Paragraph';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  disabled: boolean;
  looks_inactive?: boolean;
  result: string;
  notice: string;
  visibility: boolean;
}

const PreliminaryExaminationResult: React.FC<Props> = ({
  id,
  label,
  need,
  disabled,
  looks_inactive,
  result,
  notice,
  visibility,
}) => {
  const [is_open, setIsOpen] = useState(true);

  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのエレメント
   */
  const returnLabelJsx = () => {
    return (
      <Row>
        <Col>
          <Paragraph css_class="text-area" label={convertLine(notice)} />
        </Col>
      </Row>
    );
  };

  return (
    <div className={`${!visibility && 'preliminary_examination_result_hidden'}`}>
      <ShelfInShelf 
        id={id}
        label={label}
        is_open={is_open}
        handleClick={() => setIsOpen(!is_open)}
      >
        <RowTemplate
          label="事前審査結果"
          need={need}
          disabled={disabled}
          looks_inactive={looks_inactive}
          show={true}
          content={<>{result}</>}
        />
        <RowTemplate
          label="お客様へのお知らせ"
          need={need}
          disabled={disabled}
          looks_inactive={looks_inactive}
          show={true}
          content={returnLabelJsx()}
        />
      </ShelfInShelf>
    </div>
  );
};

export default PreliminaryExaminationResult;
